module.exports = __webpack_public_path__ + "img/logo2.13c03980.svg";